import { render } from "./ViewModule.vue?vue&type=template&id=20969386"
import script from "./ViewModule.vue?vue&type=script&lang=js"
export * from "./ViewModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__